<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            class="elevation-1"
        >
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Maintenance Items</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = true"
                        >Add Maintenance Item</v-btn
                    >
                </v-toolbar>
            </template>
            
            <template v-slot:item="{ item }">
                <tr @contextmenu.prevent="openContextMenu($event, item)">
                    <td>
                        <div>{{ item.id }}</div>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.name" large @save="saveItem(item)">
                            <div>{{ item.name }}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.name" label="Name" single-line></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.description" large @save="saveItem(item)">
                            <div>{{ item.description }}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.description" label="Description" single-line></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                    <td>
                        <v-edit-dialog :return-value.sync="item.unit_of_measure" large @save="saveItem(item)">
                            <div>{{ item.unit_of_measure }}</div>
                            <template v-slot:input>
                                <v-text-field v-model="item.unit_of_measure" label="Unit Of Measure" single-line></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </td>
                </tr>
            </template>

        </v-data-table>
        <NewItemEntry :dialog="dialog" @update:dialog="dialog = $event" :subcategories="subcategories" />
    </div>
</template>

<script>
import axios from 'axios';
import NewItemEntry from './Dialogs/NewItemEntry.vue';
export default {
    name: 'MaintenanceItems',
    components: {
        NewItemEntry
    },
    props: {
        items: Array,
        headers: Array
    },
    data() {
        return {
            dialog: false,
            subcategories: [],
            search: '',
        };
    },
    methods: {
        saveItem(item) {
            console.log('From save item');
            console.log(item);
            
            axios
                .put('v2/maintenance/inventory/items/' + item.id, item)
                .then(response => {
                    console.log(response.data);
                    
                    this.$store.dispatch('setSnackbar', {
                        text: 'Item updated',
                        color: 'success'
                    });
                   
                    //Emmit an event to update the table
                    this.$emit('update');
                })
                .catch(error => {
                    console.log(error);
                    
                    this.$store.dispatch('setSnackbar', {
                        text: 'Error updating item',
                        color: 'error'
                    });
                });
        },
        getSubcategories() {
            console.log("Get Subcategories");
            axios
                .get(
                    '/v2/maintenance/subcategories/get/by-item',
                    this.authorization
                )
                .then(response => {
                    console.log("subcategories: ", response.data);
                    this.subcategories = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        openContextMenu(event, item) {
            item = { ...item, catalogKey: 'items' };
            this.$emit('open-context-menu', { event, item });
        },
    },
    mounted() {
        this.getSubcategories();
    },
};
</script>
